import { makeInMemoryVar } from '../../apollo/inMemoryVar';

export const STORAGE_KEYS = {
  APPRAISAL_VIEW_REPORTS: 'appraisal-view-reports'
};

export const appraisalViewCustomizationReports = makeInMemoryVar(
  STORAGE_KEYS.APPRAISAL_VIEW_REPORTS,
  []
);

export const appraisalViewCache = {
  reports: {
    read: appraisalViewCustomizationReports
  }
};
